export enum MapReferenceOverlapTopology {
    ShapeEntirelyOutsideMapReference = 1,
    ShapeEntirelyWithinMapReference,
    ShapePartiallyWithinMapReference,
    ShapeDoesNotPartiallyOverlapAnyMapReferences
}